export default "__VITE_ASSET__gE0gwdnX__"